import api from '@utils/api';

export const getParkers = async (params) => {
  try {
    let url = '/parkers';
    const requestParams = { page: 1, per_page: 1000, ...params };

    if (params && params.place_id) {
      url = `/parkers/place/${params.place_id}`;
      delete requestParams.place_id;
    }

    const response = await api.get(url, { params: requestParams });
    return response.data;
  } catch (error) {
    console.error('Error fetching parkers:', error);
    throw error;
  }
};

export const getParkerByLocation = async (location) => {
  try {
    const response = await api.get(`/parkers/location/${location}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching parker by location ${location}:`, error);
    throw error;
  }
};

export const createParker = async (parkerData) => {
  try {
    const response = await api.post('/parkers', parkerData);
    return response.data;
  } catch (error) {
    console.error('Error creating parker:', error);
    throw error;
  }
};

export const updateParker = async (id, parkerData) => {
  try {
    const response = await api.put(`/parkers/${id}`, parkerData);
    return response.data;
  } catch (error) {
    console.error(`Error updating parker ${id}:`, error);
    throw error;
  }
};

export const deleteParker = async (id) => {
  try {
    const response = await api.delete(`/parkers/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting parker ${id}:`, error);
    throw error;
  }
};
